<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-newspaper-variant"
          inline
          class="ml-0 px-5 py-4"
          title="Releases e Novidades"
        >
          <div v-if="userIsAdmin" class="mt-2 text-right">
            <v-btn small outlined color="primary" :to="{ path: '/releases-novidades/gerenciar' }">
              <v-icon left small>mdi-cog</v-icon>
              Administrar
            </v-btn>
          </div>

          <div v-if="loading" class="py-8 text-center">
            <v-progress-circular indeterminate color="primary" />
          </div>

          <div v-else-if="releases.length === 0" class="py-8 text-center">
            <v-icon size="64" color="grey lighten-2">mdi-newspaper-variant-outline</v-icon>
            <p class="mt-4 text--secondary">Nenhuma novidade publicada ainda.</p>
          </div>

          <v-timeline v-else align-top dense class="mt-4">
            <v-timeline-item v-for="release in releases" :key="release.id" color="primary">
              <template v-slot:icon>
                <v-icon v-if="!release.visualizado" color="white">mdi-new-box</v-icon>
                <v-icon v-else color="white">mdi-check</v-icon>
              </template>

              <v-card elevation="1" class="mb-4">
                <v-card-title class="px-4 py-3">
                  <div class="align-center d-flex flex-wrap" style="gap: 8px">
                    <span class="font-weight-bold primary--text" style="font-size: 1.25rem">v{{ release.versao }}</span>
                    <span v-if="release.titulo" style="font-size: 1.2rem">- {{ release.titulo }}</span>
                    <v-chip v-if="!release.visualizado" color="accent" x-small dark class="ml-1">NOVO</v-chip>
                  </div>
                  <v-spacer />
                  <span style="font-size: 1rem">{{ release.data_lancamento }}</span>
                </v-card-title>

                <v-divider />

                <v-card-text class="pb-4 pt-3">
                  <div v-for="tipo in tiposOrdenados" :key="tipo.value" class="mb-4">
                    <template v-if="itensPorTipo(release, tipo.value).length">
                      <div class="align-center d-flex mb-2">
                        <v-icon :color="tipo.color" class="mr-2">{{ tipo.icon }}</v-icon>
                        <span class="body-2 font-weight-bold" :style="`color: ${tipo.color}`">
                          {{ tipo.label }}
                        </span>
                      </div>
                      <div
                        v-for="(item, idx) in itensPorTipo(release, tipo.value)"
                        :key="idx"
                        class="align-start body-1 d-flex mb-2 pl-1"
                      >
                        <v-icon :color="tipo.color" small class="mr-2 mt-1" style="flex-shrink: 0">mdi-circle-medium</v-icon>
                        <span style="white-space: pre-wrap">{{ item.descricao }}</span>
                      </div>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ReleasesNovidadesService from '@/services/ReleasesNovidadesService';

  const TIPOS = [
    { value: 'nova_funcionalidade', label: 'Novas Funcionalidades', icon: 'mdi-star', color: '#4CAF50' },
    { value: 'melhoria', label: 'Melhorias', icon: 'mdi-arrow-up-bold', color: '#2196F3' },
    { value: 'correcao', label: 'Correções', icon: 'mdi-wrench', color: '#F44336' },
    { value: 'mudanca_importante', label: 'Mudanças Importantes', icon: 'mdi-alert', color: '#FF9800' }
  ];

  export default {
    name: 'ReleasesNovidades',

    data: () => ({
      releases: [],
      loading: false,
      tiposOrdenados: TIPOS
    }),

    computed: {
      userIsAdmin() {
        return this.$store.getters.getUserIsAdmin;
      }
    },

    mounted() {
      this.getReleases();
    },

    methods: {
      getReleases() {
        this.loading = true;
        ReleasesNovidadesService.getReleases()
          .then(({ data }) => {
            this.releases = data.data;
            this.marcarNaoVisualizadasComoVistas();
          })
          .catch(() => {
            this.$toast.error('Erro ao carregar as releases.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      marcarNaoVisualizadasComoVistas() {
        const naoVisualizadas = this.releases.filter((r) => !r.visualizado);
        if (!naoVisualizadas.length) return;
        naoVisualizadas.forEach((r) => ReleasesNovidadesService.marcarVisualizado(r.id));
        this.$root.$emit('releases-visualizadas');
      },

      itensPorTipo(release, tipo) {
        return release.itens.filter((i) => i.tipo === tipo);
      }
    }
  };
</script>
